// TODO: changes to staff (add and edit) doesn't reflect on staff list on-spot #BUG

import React, { Component } from 'react'
import axios from 'axios'

// firebase
import { exportHandFunction } from '../../atoms/firebase'

import { Label } from '../../atoms/label'
import * as Firebase from '../../atoms/firebase'
import { Title } from '../../atoms/title'
import { Loader } from '../../atoms/loader'
import { Button } from '../../atoms/button'
import { Inputbox } from '../../atoms/inputbox'
import { DropDownOptions } from '../../atoms/dropDropOptions'
import { Card } from '../../molecules/card'
import { Modal } from '../../molecules/modal'
import { DesignerCard } from '../../molecules/designerCard'
import { StaffCard } from '../../molecules/staffCard'
import { FileInput } from '../../molecules/fileInput'
import { LoaderCard } from '../../molecules/loaderCard'
import { CardPresenter } from '../../organisms/cardPresenter'

// statics
import brandLogo from '../../assets/images/brandIcon.svg'
import dailySummany from '../../assets/images/dailySummary.svg'
import staffIcon from '../../assets/images/staffIcon.svg'
import logoutIcon from '../../assets/images/logout.svg'

// styles
import styles from './dashboard.module.css'

const adminURL = 'https://us-central1-onlive-poker-dev.cloudfunctions.net/admin/main/'
const staffURL = 'https://us-central1-onlive-poker-dev.cloudfunctions.net/admin/staff/'

export class Dashboard extends Component {

    state = {
        playersLoading: true,
        statsLoading: true,
        tableLoading: true,
        playerError: null,
        statsError: null,
        tableError: null,
        modalContent: [],
        data: [],
        dataName: [],
        headers: [],
        staffList: {},
        loading: true,
        imagePPLoading: false,
        error: null,
        imagePPError: null,
        message: null,
        staffFormError: null,
        newStaff: false,
        isNotSamePassword: false,
        newStaffInfo: {},
        editStaff: false,
        editStaffInfo: {},
        cardType: null,
        export: {
            date: null,
            email: null,
        },
        exportLoading: false,
        exportError: null,
    }

    componentDidMount() {
        axios.get(adminURL + 'casinostats')
            .then(response => this.setState({ ...response.data, statsLoading: false, statsError: false }))
            .catch(error => {
                if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) this.setState({ statsError: error.response.data.message, statsLoading: false })
                else this.setState({ statsError: 'Some error has occured. Please try again.', statsLoading: false })
            })
        axios.get(adminURL + 'checkedinplayersinfo')
            .then(response => this.setState({ ...response.data, playersLoading: false, playerError: false }))
            .catch(error => {
                if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) this.setState({ playerError: error.response.data.message, playersLoading: false })
                else this.setState({ playerError: 'Some error has occured. Please try again.', playersLoading: false })
            })
        axios.get(adminURL + 'tables')
            .then(response => this.setState({ ...response.data, tableLoading: false, tableError: false }))
            .catch(error => {
                if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) this.setState({ tableError: error.response.data.message, tableLoading: false })
                else this.setState({ tableError: 'Some error has occured. Please try again.', tableLoading: false })
            })
        axios.get(staffURL + 'list')
            .then(response => {
                if (response.status === 200 || response.status === 304) {
                    this.setState({ loading: false, staffList: response.data || {} })
                } else {
                    this.setState({ loading: false, error: "Error with " + response.status + " status code." })
                }
            })
            .catch(error => {
                if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) {
                    this.setState({ loading: false, error: error.response.data.message })
                } else {
                    this.setState({ loading: false, error: "An error has occured." })
                }
            })
    }

    componentDidUpdate = (prevProp, prevState, snapshot) => {
        if (this.state.cardType === 'dailySummary') {
            if (this.state.statsLoading !== prevState.statsLoading ||
                this.state.statsError !== prevState.statsError) {
                this.onCardClick('dailySummary')
            }
        } else if (this.state.cardType === 'staffManager') {
            if (this.state.loading !== prevState.loading ||
                this.state.error !== prevState.error) {
                this.onCardClick('staffManager')
            }
        }
    }

    onCardClick = cardType => {
        var modalContent = []
        switch (cardType) {
            case 'dailySummary':
                if (this.state.statsLoading) {
                    modalContent.push(<LoaderCard loading />)
                } else {
                    if (!!this.state.statsError) {
                        modalContent.push(<LoaderCard error={this.state.statsError} />)
                    } else {
                        if ('CasinoStats' in this.state && 'dailySummary' in this.state.CasinoStats) {
                            Object.keys(this.state.CasinoStats.dailySummary)
                                .filter(key => Object.keys(this.state.CasinoStats.dailySummary[key]).includes('date'))
                                .map(key => {
                                    var dayProperty = Object.keys(this.state.CasinoStats.dailySummary[key])
                                    var dayProperties = {}
                                    dayProperty.map(prop => {
                                        dayProperties[prop] = this.state.CasinoStats.dailySummary[key][prop]
                                        return null
                                    })
                                    modalContent.push(<Card key={key} {...dayProperties} export={this.onExportClick} />)
                                    return null
                                })
                        } else {
                            modalContent.push(<LoaderCard error="Unformatted data. Check with administration." />)
                        }
                    }
                }
                this.setState({
                    cardType: 'dailySummary',
                    modalContent: modalContent,
                    dataName: window.innerWidth < 1200 ? [<Title>Daily Summary</Title>] : []
                })
                break;
            case 'staffManager':
                if (this.state.loading) {
                    modalContent.push(<LoaderCard loading />)
                } else {
                    if (!!this.state.error) {
                        modalContent.push(<LoaderCard error={this.state.error} />)
                    } else {
                        if (Object.keys(this.state.staffList).length !== 0) {
                            Object.keys(this.state.staffList).map(staffId => {
                                modalContent.push(<StaffCard
                                    key={staffId}
                                    name={this.state.staffList[staffId].display}
                                    profilePic={this.state.staffList[staffId].profilePicUrl}
                                    role={this.state.staffList[staffId].role}
                                    email={this.state.staffList[staffId].email}
                                    onliveId={this.state.staffList[staffId].onliveID}
                                    onEditClick={() => this.onEditStaffClick(staffId)} />)
                                return null;
                            })
                        } else {
                            modalContent.push(<Label info>No staff found.</Label>)
                        }
                    }
                }
                this.setState({
                    cardType: 'staffManager',
                    modalContent: modalContent,
                    dataName: [<Title capital>staff</Title>, <Label onClick={this.onNewStaffClick}>+</Label>],
                })
                break;
            default:
                this.setState({ cardType: null, modalContent: [] })
                break;
        }
    }

    onNewStaffClick = () => {
        this.setState(prevState => {
            return { newStaff: !prevState.newStaff, staffFormError: null, isNotSamePassword: false }
        })
    }

    onNewStaffDetailsChange = e => {
        if (e.target.name === 'password') {
            this.onNewStaffPasswordChange(e)
        }
        this.setState({
            newStaffInfo: {
                ...this.state.newStaffInfo,
                [e.target.name]: e.target.value,
            }
        })
    }

    onNewStaffPasswordChange = e => {
        if ('password' in this.state.newStaffInfo) {
            if (e.target.value !== this.state.newStaffInfo.password) {
                this.setState({ isNotSamePassword: true })
            } else {
                this.setState({ isNotSamePassword: false })
            }
        }
    }

    onNewStaffProfilePicChange = e => {
        if (e.target.files && e.target.files[0]) {
            let NewImage = new FileReader()
            NewImage.onload = e => {
                this.setState({
                    newStaffInfo: {
                        ...this.state.newStaffInfo,
                        profilePicUrl: e.target.result
                    }
                })
            }
            NewImage.readAsDataURL(e.target.files[0])
        }
    }

    onNewStaffSubmit = () => {
        if ('display' in this.state.newStaffInfo && !!this.state.newStaffInfo.display) {
            if ('email' in this.state.newStaffInfo && !!this.state.newStaffInfo.email) {
                if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.state.newStaffInfo.email)) {
                    if (!this.state.isNotSamePassword) {
                        if ('password' in this.state.newStaffInfo && !!this.state.newStaffInfo.password) {
                            if ('role' in this.state.newStaffInfo && !!this.state.newStaffInfo.role) {
                                let onliveIDStart = this.state.newStaffInfo.role === 'master' ? 'MA' : this.state.newStaffInfo.role === 'cashier' ? 'CA' : this.state.newStaffInfo.role === 'table-floor' ? 'TF' : null
                                let newStaff = {}
                                Object.keys(this.state.newStaffInfo).filter(key => key !== 'profilePicUrl').map(key => newStaff[key] = this.state.newStaffInfo[key])
                                newStaff['onliveID'] = onliveIDStart + Date.now()
                                axios.post(staffURL + 'add', newStaff)
                                    .then(response => {
                                        this.setState({
                                            staffList: {
                                                ...this.state.staffList,
                                                ...response.data,
                                            },
                                            staffFormError: null,
                                            imagePPLoading: true
                                        })
                                        this.onNewStaffProfilePicSubmit(response.data)
                                    })
                                    .catch(error => {
                                        if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) {
                                            this.setState({ staffFormError: error.response.data.message })
                                        }
                                    })
                            } else {
                                this.setState({ staffFormError: 'Please select a role.' })
                            }
                        } else {
                            this.setState({ staffFormError: 'Please enter a password.' })
                        }
                    } else {
                        this.setState({ staffFormError: 'Please enter same passwords.' })
                    }
                } else {
                    this.setState({ staffFormError: 'Please enter a valid email ID.' })
                }
            } else {
                this.setState({ staffFormError: 'Please enter an email ID.' })
            }
        } else {
            this.setState({ staffFormError: 'Please enter a name.' })
        }
    }

    onNewStaffProfilePicSubmit = data => {
        let fuid = Object.keys(data)[0]
        let image = document.getElementById('profilePic').files[0]
        if (!!image) {
            Firebase.storage.child(fuid).put(image)
                .then(snapshot => {
                    snapshot.ref.getDownloadURL()
                        .then(downloadURL => {
                            axios.put(staffURL + 'edit/' + fuid, { 'profilePicUrl': downloadURL })
                                .then(response => {
                                    this.setState({
                                        imagePPLoading: false,
                                        staffList: {
                                            ...this.state.staffList,
                                            [fuid]: {
                                                ...this.state.staffList[fuid],
                                                profilePicUrl: downloadURL,
                                            }
                                        }
                                    })
                                    this.onNewStaffClick()
                                })
                                .catch(error => {
                                    this.setState({
                                        imagePPLoading: false,
                                        imagePPError: 'Unable to save photo. The staff has been added though. Retry using edit staff.'
                                    })
                                })
                        })
                        .catch(error => {
                            this.setState({
                                imagePPError: 'Unable to fetch image URL. The staff has been added though. Retry using edit staff.',
                                imagePPLoading: false
                            })
                        })
                })
                .catch(error => {
                    this.setState({
                        imagePPError: 'Unable to save photo. The staff has been added though. Retry using edit staff.',
                        imagePPLoading: false
                    })
                })
        } else {
            this.setState({
                imagePPLoading: false
            })
            this.onNewStaffClick()
        }
    }

    onEditStaffClick = staffId => {
        if (staffId) {
            let thisStaff = {
                ...this.state.staffList[staffId],
            }
            Object.keys(thisStaff).filter(key => key !== 'display' && key !== 'role' && key !== 'profilePicUrl').map(delKey => delete thisStaff[delKey])
            thisStaff = {
                ...thisStaff,
                id: staffId
            }
            this.setState({
                editStaff: true,
                editStaffInfo: thisStaff,
                staffFormError: null,
            })
        } else {
            this.setState({
                editStaff: false,
                editStaffInfo: {},
                staffFormError: null,
            })
        }
    }

    onEditStaffDetailsChange = e => {
        this.setState({
            editStaffInfo: {
                ...this.state.editStaffInfo,
                [e.target.name]: e.target.value,
            }
        })
    }

    onEditStaffProfilePicChange = e => {
        if (e.target.files && e.target.files[0]) {
            let EditImage = new FileReader()
            EditImage.onload = e => {
                this.setState({
                    editStaffInfo: {
                        ...this.state.editStaffInfo,
                        profilePicUrl: e.target.result
                    }
                })
            }
            EditImage.readAsDataURL(e.target.files[0])
        }
    }

    onEditStaffSubmit = () => {
        let noError = true
        if (('role' in this.state.editStaffInfo && !this.state.editStaffInfo.role) || ('display' in this.state.editStaffInfo && !this.state.editStaffInfo.display)) { noError = false }
        if (noError) {
            let editStaffInfo = {}
            Object.keys(this.state.editStaffInfo).filter(key => key !== 'profilePicUrl').map(key => editStaffInfo[key] = this.state.editStaffInfo[key])
            axios.put(staffURL + 'edit/' + this.state.editStaffInfo.id, editStaffInfo)
                .then(response => {
                    this.setState({
                        staffList: {
                            ...this.state.staffList,
                            [this.state.editStaffInfo.id]: {
                                ...this.state.staffList[this.state.editStaffInfo.id],
                                ...response.data
                            }
                        },
                        staffFormError: null,
                        imagePPLoading: true,
                    })
                    this.onEditProfilePicSubmit(response.data)
                })
                .catch(error => {
                    if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) {
                        this.setState({ staffFormError: error.response.data.message })
                    }
                })
        }
        else {
            this.setState({ staffFormError: 'Please fill all required fields.' })
        }
    }

    onEditProfilePicSubmit = data => {
        let fuid = this.state.editStaffInfo.id
        let image = document.getElementById('editProfilePic').files[0]
        if (!!image) {
            Firebase.storage.child(fuid).put(image)
                .then(snapshot => {
                    snapshot.ref.getDownloadURL()
                        .then(downloadURL => {
                            axios.put(staffURL + 'edit/' + fuid, { 'profilePicUrl': downloadURL })
                                .then(response => {
                                    this.setState({
                                        imagePPLoading: false,
                                        staffList: {
                                            ...this.state.staffList,
                                            [fuid]: {
                                                ...this.state.staffList[fuid],
                                                profilePicUrl: downloadURL,
                                            }
                                        }
                                    })
                                    this.onEditStaffClick()
                                })
                                .catch(error => {
                                    this.setState({
                                        imagePPLoading: false,
                                        imagePPError: 'Unable to save photo. The staff has been added though. Retry using edit staff.'
                                    })
                                })
                        })
                        .catch(error => {
                            this.setState({
                                imagePPError: 'Unable to fetch image URL. The staff has been added though. Retry using edit staff.',
                                imagePPLoading: false
                            })
                        })
                })
                .catch(error => {
                    this.setState({
                        imagePPError: 'Unable to save photo. The staff has been added though. Retry using edit staff.',
                        imagePPLoading: false
                    })
                })
        } else {
            this.setState({
                imagePPLoading: false,
                imagePPError: null
            })
            this.onEditStaffClick()
        }
    }

    onExportClick = date => {
        this.setState({
            export: {
                ...this.state.export,
                date: this.state.export.date ? null : date,
                email: null,
            }
        })
    }

    exportEmailChange = e => {
        this.setState({
            export: {
                ...this.state.export,
                email: e.target.value
            }
        })
    }

    onExportSubmit = () => {
        this.setState({ exportLoading: true })
        exportHandFunction(this.state.export)
            .then(() => {
                this.setState({
                    exportLoading: false,
                    exportError: null
                })
                this.onExportClick()
            })
            .catch((error) => {
                this.setState({
                    exportLoading: false,
                    exportError: error
                })
            })
    }

    render() {
        return <div className={styles.container}>
            <a id={styles.brandLogo} href="http://onlive.poker/" ><img src={brandLogo} alt="Onlive Poker" /></a>
            <div className={styles.designerCardsRow}>
                <div className={styles.cards}>
                    <DesignerCard title="Daily Summary" subhead="Control the Onlive journey" background={dailySummany} onClick={() => this.onCardClick('dailySummary')} />
                    <DesignerCard title="Staff Management" subhead="Track the Poker Financials" background={staffIcon} onClick={() => this.onCardClick('staffManager')} />
                    <div className={styles.lastRow}>
                        {this.state.tableLoading
                            ? <DesignerCard title="Tables" loading center half />
                            : this.state.tableError
                                ? <DesignerCard title="Tables" subtitle="Error" center error half />
                                : <DesignerCard title="Tables" subtitle={Object.keys(this.state.Tables).length} center half />
                        }
                        {this.state.playersLoading
                            ? <DesignerCard title={['Players in ', <strong key="house">House</strong>]} loading center half smalltext />
                            : this.state.playerError
                                ? <DesignerCard title={['Players in ', <strong key="house">House</strong>]} subtitle="Error" center error half smalltext />
                                : <DesignerCard title={['Players in ', <strong key="house">House</strong>]} subtitle={Object.keys(this.state.CheckedInPlayersInfo).length} center half smalltext />
                        }
                    </div>
                </div>
                {this.state.modalContent.length !== 0 && <div className={styles.cardPresenter}>
                    <CardPresenter modalClose={() => this.onCardClick()} modalHeader={this.state.dataName} content={this.state.modalContent} />
                </div>
                }
            </div>
            {this.state.newStaff && <Modal header={[<Title capital>Add staff</Title>]} close={this.onNewStaffClick} small>
                <div className={styles.modalBody}>
                    <FileInput message="Add photo" name="profilePicUrl" inputId="profilePic" accept="image/*" background={'profilePicUrl' in this.state.newStaffInfo && this.state.newStaffInfo.profilePicUrl} onChange={this.onNewStaffProfilePicChange} />
                    <Inputbox name="display" placeholder="Name" onChange={this.onNewStaffDetailsChange} />
                    <Inputbox name="email" placeholder="Email ID/Mobile" onChange={this.onNewStaffDetailsChange} />
                    <Inputbox name="password" placeholder="Password" type="password" onChange={this.onNewStaffDetailsChange} />
                    <Inputbox placeholder="Confirm password" name="c_password" type="password" onChange={this.onNewStaffPasswordChange} />
                    {this.state.isNotSamePassword && <Label error>Passwords do not match!</Label>}
                    <DropDownOptions name="role" value={this.state.newStaffInfo.role} onChange={this.onNewStaffDetailsChange}>
                        <option value="">Select role</option>
                        <option value="master">Master</option>
                        <option value="table-floor">Table-Floor</option>
                        <option value="cashier">Cashier</option>
                    </DropDownOptions>
                    {!!this.state.staffFormError && <Label error>{this.state.staffFormError}</Label>}
                    {!!this.state.imagePPError && <Label error>{this.state.imagePPError}</Label>}
                    <br />
                    <Button submit primary onClick={this.onNewStaffSubmit}>Submit{this.state.imagePPLoading && <Loader small />}</Button>
                </div>
            </Modal>}
            {this.state.editStaff && <Modal header={[<Title capital>Edit staff</Title>]} close={() => this.onEditStaffClick()} small>
                <div className={styles.modalBody}>
                    <FileInput message="Edit photo" name="profilePicUrl" inputId="editProfilePic" accept="image/*" background={'profilePicUrl' in this.state.editStaffInfo && this.state.editStaffInfo.profilePicUrl} onChange={this.onEditStaffProfilePicChange} />
                    <Inputbox name="display" placeholder="New name" value={this.state.editStaffInfo.display} onChange={this.onEditStaffDetailsChange} />
                    <DropDownOptions name="role" value={this.state.editStaffInfo.role} onChange={this.onEditStaffDetailsChange}>
                        <option value="">Select role</option>
                        <option value="master">Master</option>
                        <option value="table-floor">Table-Floor</option>
                        <option value="cashier">Cashier</option>
                    </DropDownOptions>
                    {!!this.state.staffFormError && <Label error>{this.state.staffFormError}</Label>}
                    {!!this.state.imagePPError && <Label error>{this.state.imagePPError}</Label>}
                    <br />
                    <Button submit primary onClick={this.onEditStaffSubmit}>Update{this.state.imagePPLoading && <Loader small />}</Button>
                </div>
            </Modal>}
            {this.state.export.date && <Modal header={[<Title capital>Export summary</Title>]} close={this.onExportClick} small>
                <div className={styles.modalBody}>
                    <Inputbox name="date" placeholder="Export summary date" value={new Date(this.state.export.date).toDateString()} disabled />
                    <Inputbox name="email" placeholder="Email address for report" onChange={this.exportEmailChange} />
                    <Button submit primary onClick={this.onExportSubmit}>Send me a mail{this.state.exportLoading && <Loader small />}</Button>
                    {!!this.state.exportError && <Label error>{this.state.exportError}</Label>}
                </div>
            </Modal>}
            <a id={styles.logout} href="/logout"><img src={logoutIcon} alt="Logout" />Logout</a>
        </div>
    }
}